import { Modal } from '@cma/common'
import { GlobeIcon } from '@heroicons/react/solid'
import { useState } from 'react'
import { CustomizeButton } from './CustomizeButton'

export function CustomizeLanguage() {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <CustomizeButton
        icon={<GlobeIcon />}
        title="Language"
        subtitle="Default Language"
        onClick={() => setShowModal(true)}
      />
      <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
        <Modal.Title>Language</Modal.Title>
        <div className="mt-2">This is the modal content</div>
      </Modal>
    </>
  )
}
